<template>
    <div class="site-wrapper" id="page">
        <template v-for="item in salepages.sale_page_detail" :salepage="item">
            <sectionHeader v-if="item.section_type === 'header'" :item="item" />

            <sectionBanner v-if="item.section_type === 'banner'" :item="item" />

            <sectionBenefits v-if="item.section_type === 'benefits'" :item="item" />

            <sectionFeature v-if="item.section_type === 'feature'" :item="item" />

            <sectionEmbed v-if="item.section_type === 'embed'" :item="item" />

            <sectionBannerImage v-if="item.section_type === 'bannerimage'" :item="item" />

            <sectionTextCallback v-if="item.section_type === 'textcallback'" :item="item" />

            <sectionTitleCenter v-if="item.section_type === 'titlecenter'" :item="item" />

            <sectionBannerLeft v-if="item.section_type === 'bannerleft'" :item="item" />

            <sectionBanner2Column v-if="item.section_type === 'banner2column'" :item="item" />

            <sectionBannerRight v-if="item.section_type === 'bannerright'" :item="item" />
        </template>
        <!-- <div v-for="(item, index) in salepages.sale_page_detail" :key="index">
            

            
        </div>-->
        <sectionTestimonial :items="salepages" />
        <siteFooter />
        <!-- <div v-html="HTMLcontent"></div> -->
    </div>
</template>

<script>
import siteFooter from "@/views/Footer";
import sectionList from "@/components/sectionList";
import { mapGetters, mapActions, mapState } from "vuex";
import sectionTestimonial from "@/components/List/sectionTestimonial";
import sectionHeader from "@/components/List/sectionHeader";
import sectionBanner from "@/components/List/sectionBanner";
import sectionBenefits from "@/components/List/sectionBenefits";
import sectionFeature from "@/components/List/sectionFeature";
import sectionEmbed from "@/components/List/sectionEmbed";
import sectionBannerImage from '@/components/List/sectionBannerImage'
import sectionTextCallback from '@/components/List/sectionTextCallback'
import sectionTitleCenter from '@/components/List/sectionTitleCenter'
import sectionBannerLeft from '@/components/List/sectionBannerLeft'
import sectionBanner2Column from '@/components/List/sectionBanner2Column'
import sectionBannerRight from '@/components/List/sectionBannerRight'
export default {
    components: {
        sectionList,
        sectionTestimonial,
        siteFooter,
        sectionHeader,
        sectionBanner,
        sectionBenefits,
        sectionFeature,
        sectionEmbed,
        sectionBannerImage,
        sectionTextCallback,
        sectionTitleCenter,
        sectionBannerLeft,
        sectionBanner2Column,
        sectionBannerRight
    },
    data() {
        return {
            // HTMLcontent: '',
            // dataHeader: {
            //     photo_one: '',
            //     photo_two: '',
            //     share: null
            // },
            // currentUrl:
            //   window.location.protocol + '//' + window.location.host == 'http://localhost:8080'
            //     ? 'https://www.724insure.net'
            //     : window.location.protocol + '//' + window.location.host
        };
    },
    methods: {
        ...mapActions({ getSalepage: "getSalepage" })
        // ...mapActions({ getSetAffiliate: "getSetAffiliate" }),
        //...mapActions({ getSalepage: 'getSalepage' }),
        //...mapActions({ getSetAffiliate: 'getSetAffiliate' }),...mapActions({ getSetAffiliate: 'getSetAffiliate' }),
        // setHeader(item) {
        //     this.dataHeader.photo_one = this.currentUrl
        //     '/img/sale_page_single/' + item.section_value.header_photo_one
        //     this.dataHeader.photo_two = this.currentUrl + '/img/sale_page_single/' + item.section_value.header_photo_two
        // },
        // setBanner(item) {
        //     let html = ''
        //     html +=
        //         '<div class="site-banner" :style="background-image:url(' +
        //         this.currentUrl +
        //         '/sale_page_single/' +
        //         item.section_value.banner_background +
        //         ')">'
        //     html += '<div class="site-banner-product">'
        //     html += '<div class="site-banner-media site-image">'
        //     html += '<div class="site-banner-price">'
        //     html += '<h5>' + item.section_value.banner_text_center + '</h5>'
        //     html += '</div>'
        //     html += '</div>'
        //     html += '<div class="site-banner-detail">'
        //     html += '<h3>' + item.section_value.banner_title + '</h3>'
        //     html += '<h5>' + item.section_value.banner_subtitle + '</h5>'
        //     html +=
        //         '<a href="' +
        //         this.currentUrl +
        //         '/campaign_salepage_download/' +
        //         item.sale_page_section_id +
        //         '" class="btn--info btn--square btn-download" >ดาวน์โหลดแผน</a>'
        //     html += '<p>' + item.section_value.banner_detail + ' <span> (ตอบทันที)</span></p>'
        //     html += '</div>'
        //     html += '</div>'
        //     html += '</div>'
        //     this.HTMLcontent += html
        // },
        // setBenefits(item) {
        //     let html = ''
        //     html += '<div class="site-benefits">'
        //     html += '<div class="container">'
        //     html += '<div class="grid benefits-bg">'
        //     html +=
        //         '<div class="benefits-media"><img src="' +
        //         this.currentUrl +
        //         '/img/sale_page_single/' +
        //         item.section_value.benefits_photo +
        //         '"></div>'
        //     html += '<div class="benefits-detail">'
        //     html += item.section_value.benefits_text
        //     html += '</div>'
        //     html += '</div>'
        //     html += '</div>'
        //     html += '</div>'
        //     this.HTMLcontent += html
        // },
        // setFeature(item) {
        //     let class_style = ''
        //     if (item.section_value.length % 3 == 0) {
        //         class_style = 'site-feature-style1'
        //     } else {
        //         class_style = 'site-feature-style2'
        //     }
        //     let html = ''
        //     html += '<div class="site-feature">'
        //     html += '<div class="container">'
        //     html += '<div class="' + class_style + '">'
        //     item.section_value.forEach(res => {
        //         html += '<div class="site-feature-item">'
        //         html += '<div class="feature-media">'
        //         html +=
        //             '<div class="media-size"><img src="' + this.currentUrl + '/img/sale_page_single/' + res.photo + '">'
        //         html +=
        //             '<div class="icon-top-right icon-top-right-color"><i class="icon-top-right-font fas fa-check"></i></div>'
        //         html += '</div>'
        //         html += '</div>'
        //         html += '<div class="feature-topic">'
        //         html += res.detail
        //         html += '</div>'
        //         html += '</div>'
        //     })
        //     html += '</div>'
        //     html += '</div>'
        //     html += '</div>'
        //     this.HTMLcontent += html
        // },
        // setEmbed(item) {
        //     let html = ''
        //     html += '<div class="container">'
        //     html += '<div class="site-media">'
        //     html += '<div class="media-embed">'
        //     html +=
        //         '<iframe width="560" height="315" src="' +
        //         item.section_value.embed_text +
        //         '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        //     html += '</div>'
        //     html += '</div>'
        //     html += '</div>'
        //     this.HTMLcontent += html
        // },
        // get_affiliate_code_url() {
        //   var url = window.location.href
        //   var sURLVariables = url.split('/')
        //   for (let i = 0; i < sURLVariables.length; i++) {
        //     if (sURLVariables[i] == 'u') {
        //       var n = i + 1
        //     }
        //   }
        //   if (n) {
        //     return sURLVariables[n]
        //   }
        // }
    },
    computed: {
        ...mapGetters(["salepage"]),
        ...mapState({ currentUrl: state => state.currentUrl }),
        ...mapState({ salepages: state => state.salepage })
    },

    // metaInfo() {
    //     let data = this.salepage.sale_page
    //     return {
    //         meta: [
    //             { vmid: 'og:title', property: 'og:title', content: data ? data.seo_title : '' },
    //             {
    //                 vmid: 'og:image',
    //                 property: 'og:image',
    //                 content: data ? main_url + '/img/sale_page_single/' + data.seo_image : ''
    //             },
    //             {
    //                 vmid: 'og:url',
    //                 property: 'og:url',
    //                 content: data ? main_url + '/campaign/' + data.permalink : ''
    //             },
    //             { vmid: 'og:description', property: 'og:description', content: data ? data.seo_description : '' }
    //         ]
    //     }
    // },
    async mounted() {
        await this.$store.dispatch("getSalepage", GLB_permalink);
        if (this.salepage.sale_page.sale_page_id == "") {
            //alert('ไม่มีข้อมูล')
            window.location.href = main_url;
        }
        // var pamalink = this.$route.params.pamalink
        // //getMetaData(pamalink)
        // await this.getSalepage(this.$route.params.pamalink)
        // if (this.salepage.sale_page.sale_page_id == '') {
        //     alert('ไม่มีข้อมูล')
        //     //window.location.href = this.currentUrl;
        // }
        //console.log(this.salepage.sale_page)
        // if(this.$cookies.isKey('724_agent_code')){
        //   alert("Null")
        // }
        // let uri = window.location.search.substring(1)
        // let params = new URLSearchParams(uri)
        // alert(params.get('u'))
        // alert(params.get('utm_source'))
        // alert(params.get('utm_medium'))
        // alert(params.get('utm_term'))
        //this.$cookies.set('user', 'sssssssssssssss');
        //console.log(this.get_affiliate_code_url());
        //console.log(agent_code)
        //const agent_code_cookie = this.$cookies.get('724_agent_code');
        // if(agent_code_cookie){
        //     //alert(agent_code);
        //     await this.getSetAffiliate()
        // }else if(agent_code_cookie != this.$route.query.u || agent_code_cookie == ''){
        //     await this.getSetAffiliate(this.$route.query.u)
        //     //alert("No Cookie!");
        // }
        //await this.getSalepage(this.$route.params.pamalink)
        // eslint-disable-next-line
        //console.log(this.$route.query.u);
        //console.log(this.$route.params.pamalink);
        //alert(this.$route.params.pamalink);
        // this.salepage.sale_page_detail.forEach(data => {
        //     if (data.section_type == 'header') {
        //         this.setHeader(data)
        //     }
        //     if (data.section_type == 'banner') {
        //         this.setBanner(data)
        //     }
        //     if (data.section_type == 'benefits') {
        //         this.setBenefits(data)
        //     }
        //     if (data.section_type == 'feature') {
        //         this.setFeature(data)
        //     }
        //     if (data.section_type == 'embed') {
        //         this.setEmbed(data)
        //     }
        // })
    }
};
// var showAccount = $("#modal-share")
//     .mobiscroll()
//     .popup({
//         display: "center",
//         buttons: [],
//         layout: "liquid"
//     })
//     .mobiscroll("getInst");

// var showCallback = $("#modal-callback")
//     .mobiscroll()
//     .popup({
//         display: "center",
//         buttons: [],
//         layout: "liquid"
//     })
//     .mobiscroll("getInst");
</script>

<style>
</style>